module.exports = __webpack_public_path__ + "static/img/1389_phase_function_Paper_PointsHejduk_Prediction.fdbdf38.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1389_phase_function_Paper_PointsHejduk_Prediction.png
// module id = d++o
// module chunks = 0